module.exports = __webpack_public_path__ + "img/D202305_1.b498e8e1.jpg";